import React from 'react'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconSettings } from '../../../../shared/components/icons/IconSettings'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { EditModal } from '../../widgets/edit-modal/EditModal'

interface ActionCellProps {
  id: number
  role: string
}

export const ActionCell = ({ id, role }: ActionCellProps) => {
  const dispatch = useAppDispatch()

  return (
    <IconButton
      className={role === 'owner' ? 'hidden' : 'visible'}
      size='lg'
      onClick={() => dispatch(setModal({ children: <EditModal id={id} /> }))}
    >
      <IconSettings color={'#00326D'} />
    </IconButton>
  )
}
